import React from 'react';
import { SandboxPicker } from 'app/pages/Profile/SandboxPicker';

export const SandboxPickerModal: React.FC = props => (
  <SandboxPicker {...props} />
);
